/* globals document */
import { render, unmountComponentAtNode } from 'react-dom';
/**
 * Render a modal over the entire screen. Only one
 * modal can be shown at a time, but you can call
 * render repeatedly for the same or new modals.
 * Ideally, you should use it in another component's
 * componentDidUpdate() or componentDidMount() and you'll
 * be placing props/state from that component into
 * this modal.
 *
 * ModalHandler.render(<ReactComponents />)
 * ModalHandler.remove()
 */
export default class ModalHandler {
    static handle = null;

    static render(component) {
        if (!ModalHandler.handle) {
            const holder = document.createElement('div');
            holder.style.position = 'fixed';
            holder.style.top = '0';
            holder.style.bottom = '0';
            holder.style.left = '0';
            holder.style.right = '0';
            holder.style.zIndex = 10000;

            const body = document.querySelector('body');
            body.appendChild(holder);
            body.style.overflow = 'hidden';

            ModalHandler.handle = holder;
        }

        render(component, ModalHandler.handle);
    }

    static remove() {
        if (!ModalHandler.handle) { return; }

        unmountComponentAtNode(ModalHandler.handle);

        const body = document.querySelector('body');
        body.removeChild(ModalHandler.handle);
        body.style.overflow = '';

        delete ModalHandler.handle;
    }
}
